/**
 * Product type varieties module.
 * @module modules/product-type-varieties
 */

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('html5-history-api');
var PageHistory = require('lib/page-history.js');

var ProductTypePicker = require('components/product-type-picker.js');

/**
 * Initialize the module.
 * @class
 */
var ProductPicker = function(el) {
  // $el is the product slider.
  this.$el = $(el);

  this.$targets = this.$el.find('[data-post-id]');
  this.$prev = this.$el.find('[data-picker-control="previous"]');
  this.$next = this.$el.find('[data-picker-control="next"]');

  this.$picker = this.$el.find('.product-type-picker');
  this.picker = new ProductTypePicker(this.$picker[0]);

  // $info is the currently showing product info.
  this.$info = this.$el.next('.product-info');

  // productInfo is a cache of previously loaded products
  this.productInfo = {};

  var initialID = this.$info.attr('data-post-id');

  // Add the initial product to in-memory cache.
  this.productInfo[initialID] = this.$info[0];

  this.$curProduct = this.$targets.filter('[data-post-id="'+initialID+'"]');
  this.$curProduct.addClass('active');

  this.$el.on('click', '.product', this.onClickProduct.bind(this));

  this.$nav = this.$el.prev('.product-picker-nav');

  if(this.$nav.length) {
    $('.header .local-nav').empty().append(this.$nav);
      this.updateNav();
      this.$targets.filter('.active').trigger('click');
      $(window).add('main').on('scroll', function(event) {
        var infoTop = this.$info.offset().top - $('.header-bar').outerHeight();
        var scrollTop = $(event.target).scrollTop();

        $('body').toggleClass('local-nav-visible', infoTop < scrollTop);
      }.bind(this))

      this.$nav.on('change', 'select', function(event) {
        var id = event.target.value;
        this.$targets.filter('[data-post-id='+id+']').click();

        $('html, body').animate({
          scrollTop: this.$info.offset().top - $('.header-bar').outerHeight() + 1
        }, 600);
      }.bind(this));
  }

  this.$el.on('click', '[data-picker-control="previous"]:not(:disabled)', function(event) {
    this.$targets.filter('.active').prev().trigger('click');
  }.bind(this));

  this.$el.on('click', '[data-picker-control="next"]:not(:disabled)', function(event) {
    this.$targets.filter('.active').next().trigger('click');
  }.bind(this));

  this.checkProductPosition(this.$curProduct);

  // $(window).on('popstate', this.onStateChange.bind(this));
}

ProductPicker.prototype = {

  /** Update the current state with the selected product and display info. */
  onClickProduct: function(event) {
    event.preventDefault();

    var $product = $(event.currentTarget);

    if($product.hasClass('active')) {
      return;
    }

    var id = event.currentTarget.getAttribute('data-post-id');
    var title = event.currentTarget.getAttribute('data-post-title');

    console.log(title);

    PageHistory.replaceState({
      id: id
    }, title, $product.find('a').attr('href'));

    this.showProductInfo(id);
  },

  /** Show product info based on the current state. */
  onStateChange: function() {
    var location = history.location || window.location;

    if(history.state) {

      this.showProductInfo(history.state.id);

    } else {

      var url = location.href;

      var id = this.$el.find('a[href="'+url+'"]').closest('.product').attr('data-post-id');

      this.showProductInfo(id);

    }
  },

  /** Show the selected product info, loading via AJAX if necessary. */
  showProductInfo: function(id) {
    if(this.productInfo[id]) {
      this.replaceProductInfo(this.productInfo[id]);
    } else {
      $.ajax({
        url: SiteVars['json_url']+'/module/product-info/'+id,
        type: 'GET',
        success: function(response) {
          this.productInfo[id] = $(response.html)[0];
          this.replaceProductInfo(this.productInfo[id]);
        }.bind(this)
      });
    }
  },

  /** Replace the product info content and update $info. */
  replaceProductInfo: function(el) {
    this.$info.replaceWith(el);
    this.$info = $(el);

    var id = this.$info.attr('data-post-id');

    var $activeTarget = this.$targets.filter('[data-post-id="'+id+'"]');

    $activeTarget.addClass('active').siblings().removeClass('active');

    this.checkProductPosition($activeTarget);
    this.updateNav();
  },

  checkProductPosition: function(el) {
    if($(el).is(':first-child')) {
      this.$prev.attr('disabled', '');
    } else {
      this.$prev.removeAttr('disabled');
    }

    if($(el).is(':last-child')) {
      this.$next.attr('disabled', '');
    } else {
      this.$next.removeAttr('disabled');
    }
  },

  updateNav: function() {
    var $activeThumb = this.$targets.filter('.active');
    var name = $activeThumb.find('.product-name').text();
    var thumbnailSrc = $activeThumb.find('img').attr('src');
    var resourceSection = document.getElementsByClassName('product-meat-resource');
    var resourceImage = document.querySelector( '.product-meat-resource__block img' );

    this.$nav.find('.active-product-image').css({
      'background-image': 'url('+thumbnailSrc+')'
    });

    this.$nav.find('.active-product-name').text(name);

    this.$nav.attr('data-product-color', $activeThumb.attr('data-product-color'));
    this.$nav.find('select').val($activeThumb.attr('data-post-id'));

    if (resourceSection.length) {
      resourceSection[0].className = resourceSection[0].className.replace(/\sproduct-color-(.*)/, ' product-color-' + this.$nav.attr('data-product-color'));
    }

    if (resourceImage) {
      resourceImage.src = $activeThumb.attr('data-product-map-color');
    }

    var $navButtonContainer = this.$nav.find('.active-product-button');
    $navButtonContainer.empty();

    var $button = this.$info.find('.product-description a.vsc-button');

    if($button.length) {
      var $localNavButton = $button.clone();
      $navButtonContainer.append($localNavButton);
    }

    $(window).trigger('vsc-page-changed');
  },

}

/** Module constructor. */
module.exports = ProductPicker;
